export const parseHtml = (html): string | undefined =>
  new DOMParser().parseFromString(html, 'text/html').documentElement.textContent || undefined;

export const detectHtml = (string) => {
  const regexp = new RegExp(/<\/?[a-z][\s\S]*>/, 'i');

  return regexp.test(string);
};
